import React from "react";
import styles from "./MealsSummary.module.css";

const MealsSummary = () => {
  return (
    <section className={styles.summary}>
      <h2>Healthy Food at your Doorstep</h2>
      <p>Choose from a selection of mouth-watering foods for your cravings</p>
      <p>Our Priority is Health and Taste !</p>
    </section>
  );
};

export default MealsSummary;
